import script from "./AdminBrandsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBrandsPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminBrandsPage.vue?vue&type=style&index=0&id=25ff90f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ff90f8"]])

export default __exports__